import { Loading } from '../../components';
import ChatContent from './ChatContent';
import { useCurrentUser } from 'hooks';

export default function ChatPage() {
  const { data: currentUser, isLoading } = useCurrentUser();

  if (isLoading || !currentUser?.uuid) {
    return (
      <>
        <Loading />
      </>
    );
  }

  return (
    <>
      <ChatContent />
    </>
  );
}
